import Table from './Admin/Table';
import './App.css';
import Home from './component/Home';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Invoice from './invoice/Invoice';
import Login from './Admin/Login';
import ProtectedRoute from './ProtectedRoute';  

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="admin"
          element={
            <ProtectedRoute>
              <Table />
            </ProtectedRoute>
          }
        />
        <Route path="login" element={<Login />} />
        <Route path="bill/:id" element={<Invoice />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
